module.exports = __webpack_public_path__ + "img/電気回路_4_3_2.a3b02430.png";